import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "sr-only" }, "申込履歴", -1)
const _hoisted_4 = { class: "max-w-7xl mx-auto sm:px-2 lg:px-8" }
const _hoisted_5 = { class: "bg-white border-t border-b border-gray-200 shadow-sm sm:rounded-lg sm:border" }
const _hoisted_6 = {
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_7 = { class: "p-4 sm:p-6" }
const _hoisted_8 = { class: "flex items-center sm:items-start" }
const _hoisted_9 = { class: "flex-1 text-sm" }
const _hoisted_10 = { class: "font-medium text-gray-900 sm:flex sm:justify-between" }
const _hoisted_11 = { class: "bg-green-100 text-gray-600 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-gray-600" }
const _hoisted_12 = { class: "mt-2 sm:mt-0" }
const _hoisted_13 = { class: "mt-6 sm:flex sm:justify-between" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "bg-gray-100 text-gray-600 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-gray-200 dark:text-gray-600" }
const _hoisted_16 = { class: "mt-6 border-t border-gray-200 text-gray-400 pt-4 flex items-center space-x-4 divide-x divide-gray-200 text-sm font-medium sm:mt-0 sm:ml-4 sm:border-none sm:pt-0" }

import Order from "@/models/Order";
import moment from "moment";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import AppHeader from "@/components/AppHeader.vue";

// @Options({
//   components: {
//     AppHeader,
//   },
// })
// export default class OrderHistoryView extends Vue {


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderHistoryView',
  setup(__props) {

// import Order from "@/models/Order";
// import moment from "moment";
// import { Options, Vue } from "vue-class-component";

const store = useStore();

const orders = ref<Order[]>([]);

const formatDateTime = (dt: Date | undefined) => {
  if (!dt) {
    return "";
  }

  return moment(dt).format("YYYY年MM月DD日");
};

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      if (!store.state.customer) {
        return;
      }
      const result = await Order.search(store.state.customer!.id);
      orders.value = result.orders;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onMounted(() => {
  refresh();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value, (order) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "max-w-2xl mx-auto space-y-8 sm:px-4 lg:max-w-4xl lg:px-0 mb-2",
              key: order.id
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h5", null, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(order.menu_type_name), 1),
                            _createTextVNode(_toDisplayString(order.menu_name), 1)
                          ]),
                          _createElementVNode("p", _hoisted_12, "¥" + _toDisplayString(order.price), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(order.state_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(formatDateTime(order.created_at)), 1)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})